// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NestedFormController from "./nested_form_controller"
application.register("nested-form", NestedFormController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)
